import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Axios from '../../../axios/Axios';
import { HOST_URL } from '../api/Api';
import { handleUserLog } from '../../Utils/Utils';
import DashboardLeftMenu from '../DashboardLeftMenu';
import DashboardHeader from '../../Header/DashboardHeader';
import DashboardFooter from '../../Footer/DashboardFooter';

const SmsTemplateSummary = () => {
    const lStorage = JSON.parse(localStorage.getItem('login'));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    const [startDateTemplate, setStartDateTemplate] = useState(new Date());
    const [endDateTemplate, setEndDateTemplate] = useState(new Date());
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [templateSummary, setTemplateSummary] = useState(null);
    const [totalSmsData, setTotalSmsData] = useState({
        total: 0,
        delivered: 0,
        failed: 0,
        dnd: 0,
        other: 0
    })

    // Format date as YYYY-MM-DD
    const formatDate = (date) => {
        return date.toISOString().split('T')[0];
    };

    useEffect(() => {
        // Default both dates to today
        const today = new Date();
        setStartDateTemplate(today);
        setEndDateTemplate(today);
    }, []);

    const handleSearch = async () => {
        try {
            setLoadingBtn(true);
            setTemplateSummary([]); // clear table before fetch

            const paramData = {
                user_id: userId,
                method: 'template_wise_summary',
                token: userToken,
                date_from: formatDate(startDateTemplate),
                date_to: formatDate(endDateTemplate),
            };

            const { data } = await Axios.post(`${HOST_URL}/sms_report.php`, paramData);

            if (data.success && data.data) {
                // Assuming data.result is an array of summary items
                setTemplateSummary(data.data);
                let summaryDetails = data.data
                let total = 0
                let delivered = 0
                let failed = 0
                let dnd = 0
                let other = 0

                Object.keys(summaryDetails).map((item) => {
                    let innerData = summaryDetails[item]
                    total += (parseInt(innerData.delivered) + parseInt(innerData.fail_count) + parseInt(innerData.dnd_count) + parseInt(innerData.other_count))
                    delivered += parseInt(innerData.delivered)
                    failed += parseInt(innerData.fail_count)
                    dnd += parseInt(innerData.dnd_count)
                    other += parseInt(innerData.other_count)
                });

                setTotalSmsData({
                    total: total,
                    delivered: delivered,
                    failed: failed,
                    dnd: dnd,
                    other: other
                })


            } else {
                setTemplateSummary([]);
            }
        } catch (error) {
            console.error('Error fetching template summary:', error);
        } finally {
            setLoadingBtn(false);
        }
    };

    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div className="main">
                <DashboardHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className=" mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    <strong>Reports </strong> Details{" "}
                                </h3>
                            </div>
                        </div>

                        {(templateSummary && Object.keys(templateSummary).length > 0) &&
                            <div className="row">
                                <div className="col-sm-2">
                                    <div className="card">
                                        <div className="card-body p-2">
                                            <h5 className="card-title mb-0" style={{ fontSize: "12px" }}>Total</h5>
                                            <h6 className="mt-0 mb-0">
                                                {totalSmsData.total}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="card">
                                        <div className="card-body p-2">
                                            <h5 className="card-title mb-0">Delivered</h5>
                                            <h6 className="mt-0 mb-0">
                                                {totalSmsData.delivered}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="card">
                                        <div className="card-body p-2">
                                            <h5 className="card-title mb-0">Failed</h5>
                                            <h6 className="mt-0 mb-0">
                                                {totalSmsData.failed}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="card">
                                        <div className="card-body p-2">
                                            <h5 className="card-title mb-0">DND</h5>
                                            <h6 className="mt-0 mb-0">
                                                {totalSmsData.dnd}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-sm-2">
                                    <div className="card">
                                        <div className="card-body p-2">
                                            <h5 className="card-title mb-0">Other</h5>
                                            <h6 className="mt-0 mb-0">
                                                {totalSmsData.other}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        <div className="">
                            <div className="card">
                                <div className="">
                                    <h5 className="card-title  mt-5">
                                        <div className="col-auto ml-auto text-right mt-n1">
                                            <nav className="text-center" aria-label="breadcrumb">
                                                <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                    <Link to="/dashboard/sms-report">
                                                        <li onClick={() => handleUserLog("", "today_summary_tab", "sms_template_summary", "User Click on Today Summary tab in report", "sms_template_summary", "", "")} className="breadcrumb-item">
                                                            {" "}
                                                            Today's Summary{" "}
                                                        </li>{" "}
                                                    </Link>
                                                    <Link
                                                        to={
                                                            "/dashboard/sms-detail-reports/" +
                                                            "sms/" +
                                                            formatDate(startDateTemplate) +
                                                            "/" +
                                                            formatDate(endDateTemplate)
                                                        }
                                                    >
                                                        {" "}
                                                        <li onClick={() => handleUserLog("", "detailed_reports_tab", "sms_template_summary", "User Click on Detailed Reports tab in report", "sms_template_summary", "", "")} className="breadcrumb-item">
                                                            {" "}
                                                            Detailed Reports{" "}
                                                        </li>{" "}
                                                    </Link>
                                                    <Link
                                                        to={
                                                            "/dashboard/sms-template-summary/"
                                                        }
                                                    >
                                                        {" "}
                                                        <li onClick={() => handleUserLog("", "template_summary_tab", "sms_template_summary", "User Click on Template Summary tab in report", "sms_template_summary", "", "")} className="breadcrumb-item active">
                                                            {" "}
                                                            Template Summary{" "}
                                                        </li>{" "}
                                                    </Link>
                                                </ol>
                                            </nav>
                                        </div>
                                    </h5>
                                </div>

                                <div className="card-body">
                                    {/* Date Filters Row */}
                                    <div className="row align-items-end mb-4">
                                        {/* From Date */}
                                        <div className="col-md-5">
                                            <label htmlFor="fromDate" className="form-label fw-bold">
                                                From:
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </span>
                                                <ReactDatePicker
                                                    id="fromDate"
                                                    className="form-control"
                                                    dateFormat="yyyy-MM-dd"
                                                    selected={startDateTemplate}
                                                    onChange={(date) => setStartDateTemplate(date)}
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                        </div>

                                        {/* To Date */}
                                        <div className="col-md-5">
                                            <label htmlFor="toDate" className="form-label fw-bold">
                                                To:
                                            </label>
                                            <div className="input-group">
                                                <span className="input-group-text">
                                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                                </span>
                                                <ReactDatePicker
                                                    id="toDate"
                                                    className="form-control"
                                                    dateFormat="yyyy-MM-dd"
                                                    selected={endDateTemplate}
                                                    onChange={(date) => setEndDateTemplate(date)}
                                                    minDate={startDateTemplate}
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                        </div>

                                        {/* Search Button */}
                                        <div className="col-md-2 text-center">
                                            <button
                                                className="btn btn-success w-100 mt-3"
                                                onClick={() => {
                                                    handleUserLog("", "search_button", "sms_template_summary", "User Click on Search Button in report", "sms_template_summary", "", { date_from: formatDate(startDateTemplate), date_to: formatDate(endDateTemplate) });
                                                    handleSearch();
                                                }}
                                                disabled={loadingBtn}
                                            >
                                                {loadingBtn ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Loading...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FontAwesomeIcon icon={faSearch} /> Search
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Table Section */}
                                    <div className="table-responsive mt-4">
                                        {templateSummary && Object.keys(templateSummary).length > 0 ? (
                                            <table className="table table-striped table-hover align-middle text-center">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th scope="col">Template ID</th>
                                                        <th scope="col">Template Name</th>
                                                        <th scope="col">Total</th>
                                                        <th scope="col">Delivered</th>
                                                        <th scope="col">Failed</th>
                                                        <th scope="col">DND</th>
                                                        <th scope="col">Other</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.keys(templateSummary).map((item, index) => {
                                                        const templateData = templateSummary[item];
                                                        return (
                                                            <tr key={index}>
                                                                <td>{item}</td>
                                                                <td className="text-start">{templateData.name}</td>
                                                                <td>{parseInt(templateData.delivered) + parseInt(templateData.fail_count) + parseInt(templateData.dnd_count) + parseInt(templateData.other_count)}</td>
                                                                <td>{templateData.delivered}</td>
                                                                <td>{templateData.fail_count}</td>
                                                                <td>{templateData.dnd_count}</td>
                                                                <td>{templateData.other_count}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center py-4 text-muted border rounded">
                                                <h6>No Record Found</h6>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <DashboardFooter />
            </div>
        </div>
    )
}

export default SmsTemplateSummary